export const IVA_POLICIES_ENDPOINTS = {
  METADATA: 'admin/pickup_policy/metadata',
  FETCH_BY_COMPLAINT_TYPE:
    'admin/iva_policies/ctype_guidelines/fetch_by_complaint_type',
  CREATE_OR_UPDATE: 'admin/iva_policies/ctype_guidelines/create_or_update',
  BULK_CREATE_OR_UPDATE:
    'admin/iva_policies/ctype_guidelines/bulk_create_or_update',
  MAPPINGS_FETCH: 'admin/iva_policies/ctype_guidelines/mappings/fetch',
  MAPPINGS_CREATE_OR_UPDATE:
    'admin/iva_policies/ctype_guidelines/mappings/create_or_update',
  MAPPINGS_BULK_CREATE_OR_UPDATE:
    'admin/iva_policies/ctype_guidelines/mappings/bulk_create_or_update',
  MAPPINGS_DELETE: 'admin/iva_policies/ctype_guidelines/mappings/delete',
  PUBLISH: 'admin/iva_policies/ctype_guidelines/publish',
  RESPAWN: 'admin/iva_policies/ctype_guidelines/respawn',
  VERSIONS: 'admin/iva_policies/ctype_guidelines/versions',
};

// Fallback for the Complaint Type dropdown, used when admin/pickup_policy/metadata
// fails or returns nothing (e.g. the agent lacks the pickup-policy roles). Snapshot of
// resolution-service's pickup complaint_types list — refresh it if new types are added.
export const FALLBACK_COMPLAINT_TYPES = [
  'COMPLAINT_PRINT_QUALITY_ISSUE',
  'COMPLAINT_EMERGENCY_ISSUE',
  'COMPLAINT_IMPROPER_CUTTING',
  'COMPLAINT_TORN_ITEM',
  'COMPLAINT_EXPIRED_ITEM',
  'COMPLAINT_DELIVERY_CHARGE',
  'COMPLAINT_HANDLING_CHARGE',
  'COMPLAINT_WRONG_VARIATION',
  'COMPLAINT_MISSING_PART',
  'COMPLAINT_EMPTY_BOX',
  'COMPLAINT_ROTTEN_ITEM',
  'COMPLAINT_SURGE_CHARGE',
  'COMPLAINT_DAMAGED_FREE_GIFT',
  'COMPLAINT_DSR_ISSUE',
  'COMPLAINT_ORDER_PACKAGING_ISSUE',
  'COMPLAINT_NO_CUTTING',
  'COMPLAINT_INCORRECT_PAGE',
  'COMPLAINT_FREEBIE_MISSING',
  'COMPLAINT_PACKAGING_ISSUE',
  'COMPLAINT_CANCELLATION_FEE',
  'COMPLAINT_CUSTOMER_NOT_SATISFIED',
  'COMPLAINT_ORDERED_BY_MISTAKE',
  'COMPLAINT_GIFT_PACKING_CHARGE',
  'COMPLAINT_FESTIVAL_CHARGE',
  'COMPLAINT_USED_ITEM',
  'COMPLAINT_PRICE_MISMATCH',
  'SYSTEM_PAY_BEFORE_DELIVERY',
  'COMPLAINT_PROFESSIONAL_DID_NOT_ARRIVE',
  'COMPLAINT_FAULTY_ITEM',
  'COMPLAINT_SEAL_TAMPERED',
  'COMPLAINT_EXPECTATION_MISMATCH',
  'COMPLAINT_BULK_REFUND',
  'COMPLAINT_FOREIGN_OBJECT_FOUND',
  'COMPLAINT_GESTURE_OF_GOODWILL',
  'COMPLAINT_SMELL_OR_TASTE_ISSUE',
  'COMPLAINT_MISSING_FREE_GIFT',
  'COMPLAINT_LEAKAGE_ISSUE',
  'SYSTEM_PROCUREMENT_UPDATE',
  'SYSTEM_NOT_PROCURED',
  'SYSTEM_CANCEL',
  'COMPLAINT_EXCEPTIONAL_RESOLUTION',
  'COMPLAINT_QUALITY_EXPECTATION_MISMATCH',
  'COMPLAINT_QUALITY_ISSUE',
  'COMPLAINT_FAKE_OR_DUPLICATE_ITEM',
  'SYSTEM_PRICE_CHANGED',
  'COMPLAINT_PDP_ISSUE',
  'COMPLAINT_WRONG_ORDER',
  'COMPLAINT_COLOUR_EXPECTATION_MISMATCH',
  'COMPLAINT_QUANTITY_MISMATCH',
  'COMPLAINT_WRONG_ITEM',
  'COMPLAINT_DEFAULT',
  'COMPLAINT_REFUND_CANCELLED_ORDER',
  'COMPLAINT_USER_CANCEL',
  'COMPLAINT_IMPROPER_OR_INCOMPLETE_SERVICE',
  'COMPLAINT_DESIGN_EXPECTATION_MISMATCH',
  'COMPLAINT_MISSING_ITEM',
  'COMPLAINT_AUDIO_ISSUE',
  'COMPLAINT_BLUETOOTH_ISSUE',
  'COMPLAINT_MELTED_ISSUE',
  'COMPLAINT_PARTIAL_ITEM_MISSING',
  'COMPLAINT_ORDER_NOT_DELIVERED',
  'COMPLAINT_RETURN_OR_EXCHANGE',
  'COMPLAINT_PAPER_QUALITY_ISSUE',
  'COMPLAINT_DAMAGED_ITEM',
  'COMPLAINT_ORIENTATION_MISMATCH',
  'COMPLAINT_DELIGHT_RESOLUTION',
  'COMPLAINT_SPILLED_ITEM',
  'COMPLAINT_CONVENIENCE_CHARGE',
  'COMPLAINT_NIGHT_CHARGE',
  'COMPLAINT_ITEM_CASHBACK',
  'COMPLAINT_COLOR_ISSUE',
  'COMPLAINT_QUALITY_ISSUE_FREE_GIFT',
  'COMPLAINT_NEAR_EXPIRY',
  'COMPLAINT_SIZE_ISSUE',
];

export const IVA_TAB = {
  GUIDELINES: 'GUIDELINES',
  MAPPINGS: 'MAPPINGS',
  VERSIONS: 'VERSIONS',
};

export const IvaTabs = [
  { key: IVA_TAB.GUIDELINES, title: 'Guidelines' },
  { key: IVA_TAB.MAPPINGS, title: 'Category Mappings' },
  { key: IVA_TAB.VERSIONS, title: 'Versions' },
];

export const LOOKUP_TYPE = {
  CATEGORY: 'category',
  GROUP: 'group',
};

export const LookupTypeOptions = [
  { label: 'Category', value: LOOKUP_TYPE.CATEGORY },
  { label: 'Cohort (Group)', value: LOOKUP_TYPE.GROUP },
];

export const LOOKUP_TYPE_ID_LABEL = {
  [LOOKUP_TYPE.CATEGORY]: 'Category ID',
  [LOOKUP_TYPE.GROUP]: 'Cohort ID',
};

export const LOOKUP_TYPE_ID_PLACEHOLDER = {
  [LOOKUP_TYPE.CATEGORY]: 'e.g. 8058',
  [LOOKUP_TYPE.GROUP]: 'e.g. 100001',
};

export const ROLLOUT_GROUP = {
  CONTROL: 'ControlGroup',
  TARGET: 'TargetGroup',
};

export const RolloutGroupOptions = [
  { label: 'Target Group', value: ROLLOUT_GROUP.TARGET },
  { label: 'Control Group', value: ROLLOUT_GROUP.CONTROL },
];

export const STEP_GUIDELINE_TYPE = {
  SUMMARY: 'media_summarization_guidelines',
  VERIFICATION: 'step_by_step_verification_guidelines',
};

export const StepGuidelineTypeOptions = [
  { label: 'Summary Guideline', value: STEP_GUIDELINE_TYPE.SUMMARY },
  { label: 'Verification Guideline', value: STEP_GUIDELINE_TYPE.VERIFICATION },
];

export const INPUT_MODE = {
  DIRECT: 'direct',
  STEP: 'step',
};

export const InputModeOptions = [
  { label: 'Direct Guideline', value: INPUT_MODE.DIRECT },
  { label: 'Step Guideline', value: INPUT_MODE.STEP },
];

export const DIRECT_STEP_TITLE = 'Prompt';

export const SKELETON_ROWS = [
  { cols: 1, height: '2.4rem', width: '200px' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 1, height: '3.6rem', width: '130px' },
];

export const inputClassName =
  'tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0 focus:tw-ring-[1.5px] tw-w-full focus:tw-ring-base-green focus:tw-border-base-green tw-border tw-border-solid tw-border-[#cfcfcf]';

export const textAreaClassName =
  'tw-appearance-none tw-px-5 tw-py-3 tw-rounded-lg tw-outline-0 focus:tw-ring-[1.5px] tw-w-full focus:tw-ring-base-green focus:tw-border-base-green tw-border tw-border-solid tw-border-[#cfcfcf] tw-min-h-[96px] tw-resize-y';
